import React, { useState } from 'react'
import { FormFooterButton, InputCss } from '../../../helper/CommonFunction';
import { ApiHandler } from '../../../helper/ApiHandler';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalLarge } from '../../../components/ModalComponets';

const AddBrands = ({ isOpen, onClose, setResetSearch, title }) => {
    const token = useSelector(state => state.user.userToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initialState = {
        brands_name: '',
    };

    const [formData, setFormData] = useState(initialState);

    const { brands_name } = formData;

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClose = () => {
        setFormData(initialState);
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const body = {
            brands_name: brands_name
        }

        try {
            const result = await ApiHandler('/add_brands.php', 'POST', body, token, dispatch, navigate)
            if (result.data.status === "1") {
                toast.success(result?.data.msg)
                handleClose();
                setResetSearch(true);
            } else {
                toast.error(result?.data.msg)
            }
        } catch (error) {
            handleClose();
        }
    };

    return (
        <ModalLarge isOpen={isOpen} title={title} onClose={handleClose} modalWidth={false}>
            <form onSubmit={handleSubmit} className="p-4">
                <div className='grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-4'>
                    <div>
                        <label
                            htmlFor="userId"
                            className="block text-[#222] font-semibold mb-1"
                        >
                            Brands Name
                        </label>
                        <input
                            type="text"
                            name="brands_name"
                            value={brands_name}
                            placeholder='Please Enter a Brands Name'
                            onChange={handleInputChange}
                            required
                            className={`${InputCss}`}
                        />
                    </div>
                </div>

                <FormFooterButton onClick={handleClose} />
            </form>
        </ModalLarge>
    )
}

export default AddBrands;
